export const INVITE_ROUTES = {
	INVITE: "/invite/:token",
} as const;
